import React from 'react';
import { Info } from 'lucide-react';
import { GRAD_TEXT } from './shared';

const Footer = () => (
  <footer data-testid="site-footer" style={{ borderTop: '1px solid rgba(48,43,44,0.1)', padding: '3rem 1.5rem 2rem', background: '#fff' }}>
    <div style={{ maxWidth: '1024px', margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '3rem', marginBottom: '2rem' }}>
        <div>
          <img src="/axpats-logo.webp" alt="Axpats" style={{ height: '32px', marginBottom: '1rem' }} />
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.8125rem', color: 'rgba(48,43,44,0.5)', maxWidth: '280px', lineHeight: 1.6 }}>
            AI-powered visa eligibility assessment for skilled professionals worldwide.
          </p>
        </div>
        <div>
          <h4 style={{ fontFamily: 'var(--font-body)', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#F67425', marginBottom: '1rem' }}>Contact</h4>
          <p style={{ fontSize: '0.8125rem', color: 'rgba(48,43,44,0.72)', marginBottom: '0.5rem' }}>info@axpats.com</p>
        </div>
        <div>
          <h4 style={{ fontFamily: 'var(--font-body)', fontSize: '0.65rem', fontWeight: 700, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#F67425', marginBottom: '1rem' }}>Location</h4>
          <p style={{ fontSize: '0.8125rem', color: 'rgba(48,43,44,0.72)' }}>Abu Dhabi & Dubai, UAE</p>
        </div>
      </div>

      {/* Legal disclaimer — mandatory */}
      <div
        data-testid="footer-disclaimer"
        style={{
          display: 'flex', alignItems: 'flex-start', gap: '10px',
          padding: '1rem 1.25rem', marginBottom: '1.5rem',
          background: 'rgba(48,43,44,0.03)',
          border: '1px solid rgba(48,43,44,0.1)', borderRadius: '2px',
        }}
      >
        <Info size={15} color="rgba(48,43,44,0.5)" style={{ flexShrink: 0, marginTop: '2px' }} />
        <p style={{ margin: 0, fontFamily: 'var(--font-body)', fontSize: '0.78rem', color: 'rgba(48,43,44,0.65)', lineHeight: 1.6 }}>
          <strong style={{ color: '#302B2C' }}>Disclaimer:</strong> This assessment is an informational tool and does not constitute migration consulting, legal advice, or a guarantee of visa eligibility. For personalised migration advice, please consult a licensed migration consultant.
        </p>
      </div>

      <div style={{ paddingTop: '1.5rem', borderTop: '1px solid rgba(48,43,44,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
        <p style={{ fontSize: '0.75rem', color: 'rgba(48,43,44,0.5)', margin: 0 }}><span style={{ ...GRAD_TEXT, fontWeight: 700 }}>Axpats</span> — Global Migration Simplified</p>
        <p style={{ fontSize: '0.7rem', color: 'rgba(48,43,44,0.5)', margin: 0 }}>&copy; 2026 Axpats Immigration Consultancy</p>
      </div>
    </div>
  </footer>
);

export default Footer;
